module.exports = __webpack_public_path__ + "img/logo2mix-1.c80bce89.webp";